import { render, staticRenderFns } from "./AddUOM.vue?vue&type=template&id=0f297766&"
import script from "./AddUOM.vue?vue&type=script&lang=js&"
export * from "./AddUOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports